module.exports = __webpack_public_path__ + "img/lock-unlocked-03.24b03fe3.svg";